import { CaseActionType } from "interfaces/case-action-type";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

interface LazyFetchResponse {
  count?: number;
  results?: CaseActionType[];
}

interface LazyFetchCaseActionType {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetCaseActionTypes = (): {
  loading: boolean;
  error: boolean;
  fetchCaseActionType: (queryString?: string) => Promise<LazyFetchResponse>;
} => {
  const {
    loading,
    error,
    fetchCallback
  }: LazyFetchCaseActionType = useLazyFetchV2("GET");

  return {
    loading,
    error,
    fetchCaseActionType: (queryString?: string) =>
      fetchCallback(`case_action_types?${queryString ?? ""}`)
  };
};
